const initialState = {
  status: "invalid",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case "ACTORS_LOADING":
      return {
        ...state,
        status: "loading",
      };
    case "ACTORS_SUCCESS":
      return {
        ...state,
        status: "success",
        ...action
      };
    case "ACTORS_FAILURE":
      return {
        ...state,
        status: "failure",
      };
    default:
      return state;
  }
};
